export const SCAN_LOG_OUTPUT = `
┌────────────────┐
│ Debugging Info │
└────────────────┘

  SCAN ENVIRONMENT
  versions    - semgrep 1.78.0 on python 3.11.9
  environment - running in environment git, triggering event is unknown

  CONNECTION
  Initializing scan (deployment=returntocorp, scan_id=155299)
  Enabled products: Code, Supply Chain, Secrets

  ENGINE
  Semgrep Secrets requires Semgrep Pro Engine
  Using Semgrep Pro Version: 1.77.0
  Installed at /app/.venv/lib/python3.11/site-packages/semgrep/bin/semgrep-core-proprietary


┌─────────────┐
│ Scan Status │
└─────────────┘
  Scanning 2 files tracked by git with 1159 Code rules, 833 Secrets rules:


  CODE RULES

  Language      Rules   Files          Origin      Rules
 ─────────────────────────────        ───────────────────
  <multilang>      11       4          Pro rules     850
  yaml             47       2          Community     287
                                       Custom         22


  SECRETS RULES

  Language      Rules   Files          Origin      Rules
 ─────────────────────────────        ───────────────────
  <multilang>     529       4          Pro rules     832
  yaml             86       2          Custom          1

Semgrep Pro Engine may be slower and show different results than Semgrep OSS.


┌─────────────────────────┐
│ Secrets Historical Scan │
└─────────────────────────┘


┌─────────────┐
│ Scan Status │
└─────────────┘
  Scanning 2 files tracked by git with 1159 Code rules, 833 Secrets rules:


  CODE RULES

  Language      Rules   Files          Origin      Rules
 ─────────────────────────────        ───────────────────
  <multilang>      11       4          Pro rules     850
  yaml             47       2          Community     287
                                       Custom         22


  SECRETS RULES

  Language      Rules   Files          Origin      Rules
 ─────────────────────────────        ───────────────────
  <multilang>     529       4          Pro rules     832
  yaml             86       2          Custom          1

Semgrep Pro Engine may be slower and show different results than Semgrep OSS.


┌──────────────┐
│ Scan Summary │
└──────────────┘
Some files were skipped or only partially analyzed.
  Scan was limited to files tracked by git.

CI scan completed successfully.
  Found 5 findings (0 blocking) from 14992 rules.
  Uploading scan results
  Finalizing scan           View results in Semgrep Cloud Platform:
    https://dev2.semgrep.dev/orgs/returntocorp/findings?repo=semgrep/generic-secrets-test-repo&ref=main
    https://dev2.semgrep.dev/orgs/returntocorp/supply-chain
  No blocking findings so exiting with code 0


┌────────────────────────────────┐
│ 5 Unvalidated Secrets Findings │
└────────────────────────────────┘

    foo.yaml
    ❯❱ secrets.ai.example-generic-secrets-rule.example-generic-secrets-rule
          A secret is hard-coded in the application. Secrets stored in source code, such as credentials,
          identifiers, and other types of sensitive data, can be leaked and used by internal or external
          malicious actors. It is recommended to rotate the secret and retrieve them from a secure secret
          vault or Hardware Security Module (HSM), alternatively environment variables can be used if allowed
          by your company policy.
          Details: https://sg.run/wG7qdX

            7┆ secr********************

    ❯❱ secrets.generic.api-key.yaml-string.yaml-string
          A secret is hard-coded in the application. Secrets stored in source code, such as credentials,
          identifiers, and other types of sensitive data, can be leaked and used by internal or external
          malicious actors. It is recommended to rotate the secret and retrieve them from a secure secret
          vault or Hardware Security Module (HSM), alternatively environment variables can be used if allowed
          by your company policy.
          Details: https://sg.run/8jEjlJ

           11┆ apiKey: 8932b2c1488f****************************************************

    ❯❱ secrets.ai.example-generic-secrets-rule.example-generic-secrets-rule
          A secret is hard-coded in the application. Secrets stored in source code, such as credentials,
          identifiers, and other types of sensitive data, can be leaked and used by internal or external
          malicious actors. It is recommended to rotate the secret and retrieve them from a secure secret
          vault or Hardware Security Module (HSM), alternatively environment variables can be used if allowed
          by your company policy.
          Details: https://sg.run/wG7qdX

           13┆ secre********************

    ❯❱ secrets.generic.high-entropy-string.yaml-string.yaml-string
          A secret is hard-coded in the application. Secrets stored in source code, such as credentials,
          identifiers, and other types of sensitive data, can be leaked and used by internal or external
          malicious actors. It is recommended to rotate the secret and retrieve them from a secure secret
          vault or Hardware Security Module (HSM), alternatively environment variables can be used if allowed
          by your company policy.
          Details: https://sg.run/GnGn66

           13┆ secret: "e5^************"

    ❯❱ secrets.generic.api-key.yaml-string.yaml-string
          A secret is hard-coded in the application. Secrets stored in source code, such as credentials,
          identifiers, and other types of sensitive data, can be leaked and used by internal or external
          malicious actors. It is recommended to rotate the secret and retrieve them from a secure secret
          vault or Hardware Security Module (HSM), alternatively environment variables can be used if allowed
          by your company policy.
          Details: https://sg.run/8jEjlJ

           15┆ admin_api_key: e9dbc9a3********************************

`;
